import { toast } from 'react-toastify';
import appApi from '../../../../../../../../../api/app-api';
import { RequestEnrollment } from '../../../../../../../../../api/types/programs/course/exams/requests/request-exam-enrollment-update';
import { ExamSessionDetails } from '../../../../../../../../../api/types/programs/course/exams/response/exam-metadata';

export const upsertStudentsEnrollmentOperations = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number | undefined,
  sessionId: number | undefined,
  initialClassRegistrations: Record<number, RequestEnrollment>,
  studentClassRegistrations: Record<number, RequestEnrollment>,
  setExamDetails: (sessions: ExamSessionDetails[]) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    if (!programId || !courseId || !examId || !sessionId) {
      toast.warn('לא ניתן לאתר את מזהה הקורס ו/או התוכנית');
      return;
    }

    const getEnrollmentDelta = (
      initial: Record<number, RequestEnrollment>,
      current: Record<number, RequestEnrollment>,
    ): RequestEnrollment[] => {
      const delta: RequestEnrollment[] = [];

      // Check for additions and changes
      Object.entries(current).forEach(([studentId, currentEnrollment]) => {
        const initialEnrollment = initial[Number(studentId)];

        if (!initialEnrollment) {
          // New enrollment - include only required fields
          const enrollment: RequestEnrollment = {
            studentId: currentEnrollment.studentId,
            scheduleId: currentEnrollment.scheduleId,
          };

          if (currentEnrollment.grade) {
            enrollment.grade = currentEnrollment.grade;
          }

          if (currentEnrollment.disableSelfEnrollment !== undefined) {
            enrollment.disableSelfEnrollment =
              currentEnrollment.disableSelfEnrollment;
          }

          if (currentEnrollment.selfEnrollmentDueDate !== undefined) {
            enrollment.selfEnrollmentDueDate =
              currentEnrollment.selfEnrollmentDueDate;
          }

          if (currentEnrollment.attended !== undefined) {
            enrollment.attended = currentEnrollment.attended;
          }

          if (currentEnrollment.eligibility !== undefined) {
            enrollment.eligibility = currentEnrollment.eligibility;
          }

          if (currentEnrollment.enrollment !== undefined) {
            enrollment.enrollment = currentEnrollment.enrollment;
          }

          if (currentEnrollment.grade !== undefined) {
            enrollment.grade = currentEnrollment.grade;
          }

          if (currentEnrollment.appealingGrade !== undefined) {
            enrollment.appealingGrade = currentEnrollment.appealingGrade;
          }

          delta.push(enrollment);
        } else if (
          initialEnrollment.scheduleId !== currentEnrollment.scheduleId ||
          initialEnrollment.grade !== currentEnrollment.grade ||
          initialEnrollment.disableSelfEnrollment !==
            currentEnrollment.disableSelfEnrollment ||
          initialEnrollment.selfEnrollmentDueDate !==
            currentEnrollment.selfEnrollmentDueDate ||
          initialEnrollment.attended !== currentEnrollment.attended ||
          initialEnrollment.enrollment !== currentEnrollment.enrollment ||
          initialEnrollment.eligibility !== currentEnrollment.eligibility ||
          initialEnrollment.grade !== currentEnrollment.grade ||
          initialEnrollment.appealingGrade !== currentEnrollment.appealingGrade
        ) {
          const enrollment: RequestEnrollment = {
            studentId: currentEnrollment.studentId,
            scheduleId: currentEnrollment.scheduleId,
          };

          // Check if scheduleId changed
          if (initialEnrollment.scheduleId !== currentEnrollment.scheduleId) {
            // Only include the changed field plus the studentId
            enrollment.scheduleId = initialEnrollment.scheduleId;
          }

          // Add more field comparisons here as needed, e.g.:
          if (initialEnrollment.grade !== currentEnrollment.grade) {
            enrollment.grade = currentEnrollment.grade;
          }

          if (
            initialEnrollment.disableSelfEnrollment !==
            currentEnrollment.disableSelfEnrollment
          ) {
            enrollment.disableSelfEnrollment =
              currentEnrollment.disableSelfEnrollment;
          }

          if (currentEnrollment.selfEnrollmentDueDate !== undefined) {
            enrollment.selfEnrollmentDueDate =
              currentEnrollment.selfEnrollmentDueDate;
          }

          if (currentEnrollment.attended !== undefined) {
            enrollment.attended = currentEnrollment.attended;
          }

          if (
            currentEnrollment.enrollment !== undefined &&
            currentEnrollment.enrollment !== null
          ) {
            enrollment.enrollment = currentEnrollment.enrollment;
          }

          if (
            currentEnrollment.eligibility !== undefined &&
            currentEnrollment.eligibility !== null
          ) {
            enrollment.eligibility = currentEnrollment.eligibility;
          }

          if (
            currentEnrollment.grade !== undefined &&
            currentEnrollment.grade !== null
          ) {
            enrollment.grade = currentEnrollment.grade;
          }

          if (
            currentEnrollment.appealingGrade !== undefined &&
            currentEnrollment.appealingGrade !== null
          ) {
            enrollment.appealingGrade = currentEnrollment.appealingGrade;
          }

          delta.push(enrollment);
        }
      });

      /*      // Check for removals
      Object.keys(initial).forEach((studentId) => {
        if (!current[Number(studentId)]) {
          delta.push({
            studentId: Number(studentId),
            scheduleId: null,
          });
        }
      });*/

      return delta;
    };

    const deltaEnrollments = getEnrollmentDelta(
      initialClassRegistrations,
      studentClassRegistrations,
    );

    setLoading(true);
    const res = await appApi.addExamEnrollment(
      programId!,
      courseId!,
      examId!,
      sessionId,
      deltaEnrollments,
    );
    setLoading(false);

    setExamDetails(res.data.body);

    toast.success('הפעולה התבצעה בהצלחה');
  } catch (e) {
    setLoading(false);
    toast.error('הפעולה נכשלה, נסה שוב בעוד מספר רגעים...');
  }
};
